import { MedicineDetails } from '@dreryk/drerykweb-medicine-api';

type MedicineDetailsReimbursementsContentProps = {
   readonly reimbursements: MedicineDetails['reimbursements'];
};

const MedicineDetailsReimbursementsContent = (props: MedicineDetailsReimbursementsContentProps): JSX.Element => {
   return (
      <div>
         {props.reimbursements
            .map((reimbursement) => `${reimbursement.diseaseFullName} (${reimbursement.typeShortName}).`)
            .join(' ')}
      </div>
   );
};

export { MedicineDetailsReimbursementsContent };
